<div class="radio-group-container" [ngClass]="getLevelClass()">
  <div class="radio-group__label" *ngIf="showTitle">
    <basic-label [noIndent]="true" #questionLabel></basic-label>
  </div>
  <div
    class="radio-group"
    [ngClass]="{ 'radio-group--disabled': isDisabled }"
    [ngClass]="getLevelClass()"
    [ngClass]="getModifierClasses()"
  >
    <div *ngFor="let option of options; let i = index" class="radio-button">
      <input
        class="radio-button__input"
        type="radio"
        id="{{ radioGroupName }}-choice-{{ i }}"
        name="{{ radioGroupName }}"
        [attr.name]="radioGroupName"
        [(ngModel)]="selectedItem"
        value="{{ option.value }}"
        (ngModelChange)="trigger()"
        [required]="!questionItem.optional"
        [disabled]="isDisabled"
      />

      <label class="radio-button__label" for="{{ radioGroupName }}-choice-{{ i }}">
        <basic-text-input
          [disableConditionally]="!option.isEnabled"
          *ngIf="option.isDateInput"
          [propertyName]="questionItem.subProperty"
          [extraClasses]="['medium']"
          [hideLabel]="true"
          [placeholder]="'mm/yyyy'"
          [parserType]="'ShortDate'"
          [formatterType]="'date_mmyyyy'"
        ></basic-text-input>

        <div class="radio-button__description">{{ option.beforeInputDescription }}</div>
        <basic-text-input
          [disableConditionally]="!option.isEnabled"
          *ngIf="option.isTextInput"
          [extraClasses]="['small']"
          [propertyName]="questionItem.subProperty"
          [hideLabel]="true"
          [isSandwich]="option.isSandwich"
          [placeholder]="''"
        ></basic-text-input>
        <div class="radio-button__description">{{ option.description }}</div>
      </label>
    </div>
  </div>
</div>
